module.exports = __webpack_public_path__ + "img/np2.96532cdd.png";